export default __webpack_public_path__ + "static/media/kaspi-logo.26f30f1f.svg";